module.exports = __webpack_public_path__ + "static/media/detail5.8a0abb0b.jpg";